<template>
    <modal id="day-shift-modal"
           v-model="showModal"
           :title="generateModalTitle('day_shift')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : DAY_SHIFT'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ $t('name') }} <span class="text-danger">*</span></label>
                        <app-input
                            :placeholder="$placeholder('name')"
                            v-model="formData.name"
                            :required="true"
                            :error-message="$errorMessage(errors, 'name')"
                        />
                    </div>
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('is_holiday')"
                        type="select"
                        v-model="formData.is_holiday"
                        @change="handleMarkHolidayChange"
                        list-value-field="name"
                        :placeholder="$t('is_holiday')"
                        :error-message="$errorMessage(errors, 'is_holiday')"
                        :options="[
                            { id: 0, name: this.$t('no') },
                            { id: 1, name: this.$t('yes') }
                        ]"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('break_time')"
                        type="search-select"
                        v-model="formData.break_time_id"
                        list-value-field="name"
                        :placeholder="$t('break_time')"
                        :error-message="$errorMessage(errors, 'break_time_id')"
                        :fetch-url="`${apiUrl.BREAK_TIME}?get-all=1`"
                        :disabled="this.formData.is_holiday == 1"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('color')"
                        type="color"
                        :placeholder="$placeholder('color')"
                        v-model="formData.color"
                        :required="true"
                        :error-message="$errorMessage(errors, 'color')">
                    </app-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ $fieldTitle('start_at', '') }} <span class="text-danger" v-if="formData.is_holiday != 1">*</span></label>
                        <app-input
                            :id="'start_at'"
                            type="time"
                            v-model="formData.start_at"
                            :placeholder="$placeholder('start_at', '')"
                            name="start_at"
                            :required="formData.is_holiday != 1"
                            :error-message="$errorMessage(errors, 'start_at')"
                            :disabled="formData.is_holiday == 1"
                        />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ $fieldTitle('end_at', '') }} <span class="text-danger" v-if="formData.is_holiday != 1">*</span></label>
                        <app-input
                            :id="'end-at'"
                            type="time"
                            v-model="formData.end_at"
                            :placeholder="$placeholder('end_at', '')"
                            :required="formData.is_holiday != 1"
                            :error-message="$errorMessage(errors, 'end_at')"
                            :disabled="formData.is_holiday == 1"
                        />
                    </div>
                </div>
            </div>

            <app-form-group
                type="textarea"
                :label="$t('description')"
                :placeholder="$textAreaPlaceHolder('description')"
                v-model="formData.description"
                :required="false"
                :text-area-rows="4"
                :error-message="$errorMessage(errors, 'description')">
            </app-form-group>

        </form>
    </modal>
</template>

<script>
    import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
    import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
    import {DAY_SHIFT, SELECTABLE_DEPARTMENT} from "../../../../Config/ApiUrl";
    import { formatTime } from "../../../../../common/Helper/Support/DateTimeHelper";

    export default {
        name: "DayShiftCreateEditModal",
        mixins: [FormHelperMixins, ModalMixin],
        data() {
            return {
                formData: {
                    is_holiday: 0
                },
                DAY_SHIFT,
                SELECTABLE_DEPARTMENT
            }
        },
        methods: {
            afterSuccess({data}) {
                this.formData = {};
                $('#day-shift-modal').modal('hide');
                this.$emit('input', false);
                this.toastAndReload(data.message, 'day-shift-table');
            },
            afterSuccessFromGetEditData(response) {
                this.preloader = false;
                this.formData = response.data;
                this.formData.start_at = formatTime(this.formData.start_at);
                this.formData.end_at = formatTime(this.formData.end_at);
            },
            handleMarkHolidayChange() {
                if (this.formData.is_holiday == 1) {
                    this.formData.break_time_id = null;
                    this.formData.start_at = null;
                    this.formData.end_at = null;
                }
            }
        },
    }
</script>

